<template>
  <v-slide-x-transition>
    <v-layout v-if="items.length" justify-center>
      <v-flex shrink>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn
              @click="saveRule"
              v-on="on"
              color="green"
              :dark="!!featureValue"
              :disabled="!featureValue"
              :loading="loadingSaveRule"
              round
            >
              <v-icon>check</v-icon>
              <span class="pl-2">Guardar y mapear</span>
            </v-btn>
          </template>
          <span v-html="tooltipMessage" />
        </v-tooltip>
      </v-flex>
    </v-layout>
  </v-slide-x-transition>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapState("featureRules", [
      "feature",
      "featureValue",
      "items",
      "itemsTotal",
      "loadingSaveRule"
    ]),
    tooltipMessage() {
      return this.featureValue
        ? `Guardar regla y atributo "${this.feature.name}: ${this.featureValue}" en los ${this.itemsTotal} items`
        : "Debes asignar el valor a guardar para este feature";
    }
  },
  methods: {
    ...mapActions("featureRules", ["saveRule"])
  }
};
</script>